import { createInventoryTransactionType } from "../../api/inventoryService";

export const useCreateInventoryTransactionType = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createInventoryTransactionType(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create inventory transaction type:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};